import React from 'react';
import { Typography } from 'antd';

const { Text } = Typography;

interface CustomDescriptionItemProps {
  label: string;
  content: React.ReactNode;
  align?: 'left' | 'right';
}

const CustomDescriptionItem: React.FC<CustomDescriptionItemProps> = ({
  label,
  content,
}) => {
  return (
    <>
      <div>
        <Text strong className={'mr-1'}>
          {label}:
        </Text>
        <Text>{content}</Text>
      </div>
    </>
  );
};

export default CustomDescriptionItem;
